import Expand from './expand.js'

const initExpandHandlers = () => {
  Expand.addOpenCloseClasses()
  Expand.addOpenCloseClassesToTurboFrames()
  Expand.allowCopy()
}

if (document.readyState !== 'loading') {
  initExpandHandlers()
}

document.addEventListener('turbo:render', () => {
  initExpandHandlers()
})

document.addEventListener('turbo:load', () => {
  initExpandHandlers()
})


document.addEventListener('turbo:frame-load', () => {
  initExpandHandlers()
})

export default {}
